import { gridSize } from '@atlaskit/theme';
import styled from '@emotion/styled';

const Description = styled.p`
    margin-top: 0;
    margin-bottom: ${gridSize() * 3}px;
`;

export default Description;
